import React, {useEffect, useState} from 'react';
import {getProductOwner, StyledPopUp} from "../../../../../shared";
import {CallInformationPopUpProps, PricePopUpProps} from "../../../models";
import {Button, Card, Flex, List, message, Skeleton} from "antd";
import {IoCallSharp} from "react-icons/io5";
import style from "./CallInformationPopUp.module.scss"
import {connect} from "react-redux";
import {getProductDetail} from "../../../actions/Product.action";
import {withRouter} from "../../../../../utils/services/with-router";
import {useParams} from "react-router-dom";

const CallInformationPopUp = ({open,onCansel,getProductOwner} :CallInformationPopUpProps) => {
    const { id } = useParams();
    const [product, setProduct] =
        useState<any>();
    const [loading, setLoading] =
        useState<boolean>(true);

    const _getProductThumbnail = () => {
        setLoading(true);
        getProductOwner(id)
            .then((data: any) => {
                setLoading(false);
                if (data.payload != undefined) {

                    setProduct(data.payload);

                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        _getProductThumbnail();
    }, []);
    return (
        <StyledPopUp
        open={open}
        onCancel={onCansel}
        title={'اطلاعات تماس'}
        width={"100%"}
        footer={null}
        transitionName={''}
        >
            {loading ? <Skeleton active/> :  <Flex vertical gap={"small"}>
                <Card>
                    <Flex justify={"start"} gap={"small"}>
                        <IoCallSharp className={style.phoneIcon}/>
                        <span className={style.phoneNumber}>{product?.data}</span>

                    </Flex>
                </Card>
                <Flex gap={"small"}>
                    <Button type={"primary"} block size={"large"} onClick={() => {
                        window.location.href = `tel:${product?.data}`;

                    }}>تماس تلفنی </Button>
                    <Button type={"primary"} block size={"large"} onClick={() => {
                        window.location.href = `sms:${product?.data}`;

                    }}>ارسال پیام</Button>
                </Flex>
            </Flex>}

        </StyledPopUp>
    );
};

export default connect(null, {getProductOwner})(withRouter(CallInformationPopUp));
